import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const MobileActionBar = ({ phone = '07300 405045' }) => {
  const phoneNumber = '447300405045';
  const message = encodeURIComponent("Hi, I'm interested in getting a quote from Expert Property Maintenance for property maintenance work.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <>
      {/* Fixed mobile action bar - only visible on mobile */}
      <div 
        className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-slate-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]"
        data-testid="mobile-action-bar"
      >
        <div className="flex">
          {/* Call Button - Left half (Navy) */}
          <a
            href={`tel:${phone}`}
            className="flex-1 flex items-center justify-center gap-2 py-3 bg-brand-navy text-white font-bold text-base active:bg-brand-navy/90 transition-colors"
            data-testid="mobile-action-call"
          >
            <Phone className="w-5 h-5" />
            <span>Call Now</span>
          </a>
          
          {/* WhatsApp Button - Right half (Yellow with navy text) */}
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 py-3 bg-brand-yellow text-brand-navy font-bold text-base active:bg-yellow-400 transition-colors"
            data-testid="mobile-action-whatsapp"
          >
            <MessageCircle className="w-5 h-5" />
            <span>WhatsApp</span>
          </a>
        </div>
      </div>
      
      {/* Spacer to prevent content being hidden behind the fixed bar - increased height */}
      <div className="h-16 md:hidden" aria-hidden="true" />
    </>
  );
};

export default MobileActionBar;
